import React, { useState } from 'react'
import classes from './EditPaperInput.module.css'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Form from 'react-bootstrap/Form';
import Graybg from '../../../UI/Graybg';
import Card from '../../../UI/Card/Card';
import { Col, Row } from 'react-bootstrap';
import DatePick from '../../../Components/DatePicker/DatePicker';
import Select from '../../../UI/Select/Select';
import SecBTN from '../../../UI/SecBTN';
import Input from '../../../UI/Input/Input';
import MultiSelect from '../../../UI/MultiSelect/MultiSelect';
import ConfirmationModal from '../../../UI/ConfirmationModal/ConfirmationModal';
import SuccessModal from '../../../UI/SuccessModal/SuccessModal';

const EditPaperInput = () => {
  const [showPopUp1,setShowPopUp1] = useState(false)
  const [showPopUp2,setShowPopUp2] = useState(false)
  const popUpHandler = () => {
    setShowPopUp1(true)
  }
  const onHideHandler = () => {
    setShowPopUp1(false)
    setShowPopUp2(false)
  }
  const yesHandler = () => {
    setShowPopUp2(true)
    setShowPopUp1(false)
  }
  return (
    <div className="section">
      <ConfirmationModal title='Do you want to save this paper?' show={showPopUp1} onHide={onHideHandler} yesHandler={yesHandler} confirmTxt='Yes' />
      <SuccessModal show={showPopUp2} onHide={onHideHandler} title='Paper Requested Successfully!' btnTxt='Ok' />
      <h4>Request Paper</h4>
      <Breadcrumb>
        {/*<Breadcrumb.Item><Link to='/'> Home </Link></Breadcrumb.Item>*/}
        <Breadcrumb.Item active>Request Paper</Breadcrumb.Item>
      </Breadcrumb>
      <Graybg>
        <p className={classes.text}>Basic Details</p>
        <Card>
          <Row className="g-3">
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="session">Session :</Form.Label>
              <Select className={classes.select}>
                <option selected disabled>
                  Choose session
                </option>
                <option value="1">2021-22</option>
                <option selected value="2">2022-23</option>
                <option value="3">2023-24</option>
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Center">Center :</Form.Label>
              <MultiSelect />
              {/* <Select>
                <option selected disabled>
                  Choose Center
                </option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Select> */}
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Class">Class :</Form.Label>
              <Select>
                <option selected disabled>
                  Select Class
                </option>
                <option value="1">One</option>
                <option selected value="2">Two</option>
                <option value="3">Three</option>
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Phase">Phase</Form.Label>
              <Select>
                <option disabled>
                  Select Phase
                </option>
                <option value="1">One</option>
                <option selected value="2">Two</option>
                <option value="3">Three</option>
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Stream">Stream</Form.Label>
              <Select>
                <option disabled>
                  Select Stream
                </option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option selected value="3">Three</option>
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">Batch</Form.Label>
              <Select>
                <option disabled>
                  Select Batch
                </option>
                <option value="1">One</option>
                <option selected value="2">Two</option>
                <option value="3">Three</option>
              </Select>
            </Col>
            <Col sm={12}>
              <Form.Label htmlFor="Paper_format">Paper format</Form.Label>
              <Select>
                <option disabled>
                  Select Paper format
                </option>
                <option selected value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Select>
            </Col>
            <Col sm={12}>
              <Form.Label htmlFor="Paper_title">Paper title</Form.Label>
              <Select>
                <option disabled>
                  Select Paper title
                </option>
                <option selected value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Select>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">Exam Date :</Form.Label>
              <DatePick placeholder="Select Exam Date" />
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">
                Last date to create paper :
              </Form.Label>
              <DatePick placeholder="Select Deadline" />
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">Paper Start Time :</Form.Label>
              <DatePick placeholder="Select Paper Start Time" />
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">Paper End Time :</Form.Label>
              <DatePick placeholder="Select Paper End Time" />
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">Finalization Date :</Form.Label>
              <DatePick placeholder="Select Finalization Date" />
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Form.Label htmlFor="Batch">Paper Type</Form.Label>
              <Select>
                <option selected disabled>
                  Select Paper Type
                </option>
                <option value="1">One</option>
                <option value="2">Two</option>
                <option value="3">Three</option>
              </Select>
            </Col>
          </Row>
        </Card>
        <p className={classes.text1}>Paper Creating Faculty Details</p>
        <Card>
          <div className="text-end">
            <p>Total Chemistry Section A Questions : 30</p>
            <SecBTN className={classes["reqPaper-btn"]}>
              Add Chemistry Row
            </SecBTN>
            <Card className={classes["reqPaper-card"]}>
              <div className="d-flex flex-row justify-content-between align-items-center">
                <p className={classes.text}>Chemistry</p>
                <i className="bx bx-x"></i>
              </div>
              <div className={classes["reqPaper-grid"]}>
                <div>
                  <Form.Label htmlFor="Class">Section :</Form.Label>
                  <Select>
                    <option selected disabled>
                      Select Section
                    </option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Select>
                </div>
                <div>
                  <Form.Label htmlFor="Class">Faculty :</Form.Label>
                  <Select>
                    <option selected disabled>
                      Select Faculty
                    </option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Select>
                </div>
                <div>
                  <Form.Label htmlFor="Class">Question :</Form.Label>
                  <Select>
                    <option selected disabled>
                      Select Question
                    </option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Select>
                </div>
                <div>
                  <Form.Label htmlFor="Class">Topic :</Form.Label>
                  <Select>
                    <option selected disabled>
                      Select Topic
                    </option>
                    <option value="1">One</option>
                    <option value="2">Two</option>
                    <option value="3">Three</option>
                  </Select>
                </div>
                <div>
                  <Form.Label htmlFor="Class">Remark :</Form.Label>
                  <Input type="text" placeholder="Remark(If any)" />
                </div>
              </div>
            </Card>
          </div>
        </Card>
      </Graybg>
      <div className={classes["section-btn"]}>
        <SecBTN onClick={popUpHandler} className={classes["sec-btn"]}>
          Save Details
        </SecBTN>
      </div>
    </div>
  );
}

export default EditPaperInput